import Vue from "vue";
import axios from "axios";
import NProgress from "nprogress";
import router from './router';
import moment from 'moment';
import { Notification } from "element-ui";
import { getBaseUrl } from "@/utils/getBaseUrl";


// SET BASE URL
// export const productionAddr = process.env.VUE_APP_BASE_URL;
// console.log("getBaseUrl", getBaseUrl());
export const productionAddr = getBaseUrl();
console.log("productionAddr", productionAddr);
// Slack API failure message conf
// Slack webhook URL for sending notifications
const slackWebhookUrl = "https://hooks.slack.com/services/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";

// Function to send Slack notification
const sendSlackNotification = async (data) => {
	try {
		await fetch(slackWebhookUrl, {
			method: "POST", 
			body: JSON.stringify(data)
		  }).then(res => {
			console.log("Request complete! response:", res);
		  });
	} catch (error) {
		console.error("Failed to send Slack notification:", error);
	}
};


export const AnalyticsAddr = "https://api.nymbleup.com/api/sales";

export const serverAddr = axios.create({
	baseURL: productionAddr,
	timeout: 240000,
	headers: {},
	withCredentials: true,
	maxRedirects: 0,
	transformRequest: [
		function(data, headers) {
			const access_token = JSON.parse(
				window.localStorage.getItem("x-access-token")
			);
			if (access_token) {
				headers["Authorization"] = "Bearer" + " " + access_token;
			}
			headers["Content-Type"] = "application/json;charset=UTF-8";
			return JSON.stringify(data);
		}
	],
	transformResponse: [
		function(data) {
			if(data){
				let res = JSON.parse(data);

				// New check added
				if(res.code == "token_not_valid"){
					const r_email = localStorage.getItem('r_email');
					localStorage.clear();
					if(r_email){
					localStorage.setItem('r_email', r_email);
					}
					router.push({ path: '/' });
				}

				if(res.detail && res.detail == "Authentication credentials were not provided."){
					const r_email = localStorage.getItem('r_email');
					localStorage.clear();
					if(r_email){
					localStorage.setItem('r_email', r_email);
					}
					router.push({ path: '/' });
				}
			}
			// console.log(data);
			// if (data) {
			// 	data = JSON.parse(data);
			// }
			return data;
		}
	]
});

export const serverAddrForCSV = axios.create({
	baseURL: productionAddr,
	timeout: 240000,
	headers: {},
	withCredentials: true,
	transformRequest: [
		function(data, headers) {
			const access_token = JSON.parse(
				window.localStorage.getItem("x-access-token")
			);
			if (access_token) {
				headers["Authorization"] = "Bearer" + " " + access_token;
			}
			headers["Content-Type"] = "application/json;charset=UTF-8";
			return JSON.stringify(data);
		}
	],
	transformResponse: [
		function(data) {
			if(data){
				return data;
			}
		}
	]
});

export const serverAddrForXLSX = axios.create({
	baseURL: productionAddr,
	timeout: 240000,
	headers: {},
	withCredentials: true,
	responseType: 'blob' ,
	transformRequest: [
		function(data, headers) {
			const access_token = JSON.parse(
				window.localStorage.getItem("x-access-token")
			);
			if (access_token) {
				headers["Authorization"] = "Bearer" + " " + access_token;
			}
			headers["Content-Type"] = "application/json;charset=UTF-8";
			return JSON.stringify(data);
		}
	],
	transformResponse: [
		function(data) {
			if(data){
				return data;
			}
		}
	]
});

export const AnalyticsServerAddr = axios.create({
	baseURL: AnalyticsAddr,
	timeout: 50000,
	headers: {},
	withCredentials: true,
	transformRequest: [
		function(data, headers) {
			const access_token = JSON.parse(
				window.localStorage.getItem("x-access-token")
			);

			if (access_token) {
				headers["Authorization"] = "Bearer" + " " + access_token;
			}
			headers["Content-Type"] = "application/json;charset=UTF-8";
			return JSON.stringify(data);
		}
	],
	transformResponse: [
		function(data) {
			// console.log("data in network config", data);
			// if (data) {
			// 	data = JSON.parse(data);
			// }
			return data;
		}
	]
});
export const fileServerAddr = axios.create({
	baseURL: productionAddr,
	timeout: 30000,
	headers: {},
	withCredentials: true,
	onUploadProgress: function(progressEvent) {
		NProgress.start();
	},
	transformRequest: [
		function(data, headers) {
			const access_token = JSON.parse(
				window.localStorage.getItem("x-access-token")
			);

			if (access_token) {
				headers["Authorization"] = "Bearer" + " " + access_token;
			}
			// headers["Content-Type"] = "multipart/form-data";
			return data;
		}
	],
	transformResponse: [
		function(data) {
			NProgress.done();
			// console.log("data in network config", data);
			// if (data) {
			// 	data = JSON.parse(data);
			// }
			return data;
		}
	]
});

export const extenapiServerAddr = axios.create({
	baseURL: productionAddr,
	timeout: 6000,
	headers: {},
	withCredentials: true,
	transformRequest: [
		function(data, headers) {
			const access_token = JSON.parse(
				window.localStorage.getItem("x-access-token")
			);
			if (access_token) {
				headers["Authorization"] = "Bearer" + " " + access_token;
			}
			headers["Content-Type"] = "application/json;charset=UTF-8";
			return JSON.stringify(data);
		}
	],
	transformResponse: [
		function(data) {
			if(data){
				let res = JSON.parse(data);

				if(res.detail && res.detail == "Authentication credentials were not provided."){
					const r_email = localStorage.getItem('r_email');
					localStorage.clear();
					if(r_email){
					localStorage.setItem('r_email', r_email);
					}
					router.push({ path: '/' });
				}
			}
			// console.log(data);
			// if (data) {
			// 	data = JSON.parse(data);
			// }
			return data;
		}
	]
});

export const serverAddrUnAuth = axios.create({
	baseURL: productionAddr,
	timeout: 240000,
	headers: {},
	withCredentials: true,
	transformRequest: [
		function(data, headers) {
			headers["Content-Type"] = "application/json;charset=UTF-8";
			return JSON.stringify(data);
		}
	],
	transformResponse: [
		function(data) {
			// console.log("data in network config", data);
			// if (data) {
			// 	data = JSON.parse(data);
			// }
			return data;
		}
	]
});

serverAddr.interceptors.request.use(config => {
	NProgress.start();
	return config;
});

serverAddr.interceptors.response.use(response => {
	NProgress.done();
	return response;
},
error => {
    NProgress.done();

    // Send Slack notification on API failure
    // const notificationData = {
    //   text: "*API Failure*\n\n",
    //   attachments: [
    //     {
    //       fields: [
    //         { title: "API URL", value: error.config.url },
    //         { title: "Status", value: error.response.status },
    //         { title: "Message", value: error.response.statusText },
    //         { title: "Time", value: moment().format('MMMM Do YYYY, h:mm:ss a') },
    //         { title: "User", value: navigator.userAgent },
	// 		{ title: "API Payload", value: JSON.stringify(error.config.data) } 
    //       ]
    //     }
    //   ]
    // };
    // sendSlackNotification(notificationData);

    return Promise.reject(error);
  }
);
